import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PayPalSubscribeButton from './PayPalSubscribeButton';
import './css/PayPalSubscribeOverlay.css';

// Presentation only: PayPal approval must be verified by the authenticated backend.
class PayPalSubscribeOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.trigger = React.createRef();
    this.dialog = React.createRef();
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.open === this.state.open) return;
    if (this.state.open) {
      document.addEventListener('keydown', this.onKeyDown);
      if (this.dialog.current) this.dialog.current.focus();
    } else {
      document.removeEventListener('keydown', this.onKeyDown);
      if (this.trigger.current) this.trigger.current.focus();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(event) {
    if (event.key === 'Escape') this.close();
    if (event.key === 'Tab' && this.dialog.current) {
      const nodes = Array.from(this.dialog.current.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!nodes.length) { event.preventDefault(); return; }
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }

  open() { this.setState({ open: true }); }
  close() { this.setState({ open: false }); }

  render() {
    const spanish = this.props.language === 'spanish';
    const mobile = Boolean(this.props.mobile);
    const theme = this.props.theme === 'dark' ? 'dark' : 'light';
    return (
      <React.Fragment>
        <button
          ref={this.trigger}
          type="button"
          className={mobile ? 'tbp-pro-v55-subscribe' : 'ui button tbp-paypal-open-trigger'}
          disabled={Boolean(this.props.disabled)}
          onClick={this.open}
        >
          {mobile && <i className="user plus icon" aria-hidden="true" />}
          {spanish ? 'Suscribirme' : 'Subscribe'}
        </button>
        {this.state.open && ReactDOM.createPortal(
          <div
            className={'tbp-paypal-overlay tbp-paypal-overlay--' + theme}
            onMouseDown={event => { if (event.target === event.currentTarget) this.close(); }}
          >
            <div
              ref={this.dialog}
              className="tbp-paypal-dialog"
              role="dialog"
              aria-modal="true"
              aria-labelledby="tbp-paypal-dialog-title"
              tabIndex={-1}
            >
              <button
                type="button"
                className="tbp-paypal-close"
                aria-label={spanish ? 'Cerrar' : 'Close'}
                onClick={this.close}
              >×</button>
              <div className="tbp-paypal-dialog-kicker">BLENDER PRO PLUS</div>
              <h2 id="tbp-paypal-dialog-title">
                {spanish ? 'Completa tu suscripción' : 'Complete your subscription'}
              </h2>
              <p className="tbp-paypal-dialog-intro">
                {spanish
                  ? 'Continúa con PayPal para suscribirte. Tu acceso se habilitará después de verificar la suscripción.'
                  : 'Continue with PayPal to subscribe. Your access will be enabled after your subscription is verified.'}
              </p>
              <PayPalSubscribeButton language={this.props.language} onApproved={this.props.onApproved} getAccountId={this.props.getAccountId} />
              <p className="tbp-paypal-dialog-note">
                {spanish
                  ? 'Las cuotas cubren herramientas digitales, no transacciones financieras.'
                  : 'Membership fees cover digital features, not financial transactions.'}
              </p>
            </div>
          </div>,
          document.body
        )}
      </React.Fragment>
    );
  }
}

export default PayPalSubscribeOverlay;
